__turbopack_context__.v({
  "section": "pJL5CW_section",
  "title": "pJL5CW_title",
  "title--md": "pJL5CW_title--md",
});
